var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-render',{ref:"tableRender",attrs:{"config":_vm.tableConfig,"height":"55vh","rowKey":"userId","propData":{ query: Object.assign({}, _vm.$props) }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }